var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPragmatic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7997 11.4575L8.5817 5.66878C9.21857 4.17862 8.90356 2.42099 7.59559 1.21103C6.02055 -0.253665 3.56896 -0.387398 1.82271 0.797091L4.45235 3.24886L3.47993 4.13404L0.857145 1.70775C-0.416585 3.32527 -0.272776 5.61146 1.30227 7.06979C2.576 8.25427 4.43181 8.56632 6.02055 8.01228L12.2591 13.8137C12.5262 14.0621 12.9576 14.0621 13.2247 13.8137L14.7997 12.349C15.0668 12.0943 15.0668 11.7058 14.7997 11.4575ZM12.7453 12.47L6.26707 6.4457C5.84935 6.73227 5.38368 6.90421 4.89747 6.96789C3.96614 7.09526 2.98688 6.83416 2.27468 6.17187C1.62412 5.57325 1.32281 4.77086 1.37075 3.9812L3.48678 5.94898L6.39034 3.24886L4.2743 1.26834C5.13715 1.2365 5.97946 1.5167 6.63002 2.11531C7.3696 2.80308 7.65037 3.75194 7.47917 4.63713C7.397 5.08927 7.19156 5.50957 6.87655 5.8853L13.3548 11.9033L12.7453 12.47Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPragmatic);
export default __webpack_public_path__ + "static/media/pragmatic.fbb43b5258103d26c285428552d879da.svg";
export { ForwardRef as ReactComponent };